module.exports = __webpack_public_path__ + "img/IMG_9928_L_WoodMatted.88f8596d.jpg";